import L from "leaflet";
import {Marker} from "react-leaflet";
import { GjennomkjoringForbudt } from "../../../services/RuteplanAPI";
import gjennomkjoringForbudtIconResource from "../../../assets/GjennomkjoringForbudt.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const gjennomkjoringForbudtIcon = L.icon({
    iconUrl: gjennomkjoringForbudtIconResource,
    iconRetinaUrl: gjennomkjoringForbudtIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
});

export interface IGjennomkjoringForbudtMarkersProps {
    gjennomkjoringForbudtFeatures: Array<GjennomkjoringForbudt>;
}

export default function GjennomkjoringForbudtMarkers (props: IGjennomkjoringForbudtMarkersProps) {
    const {setClickedRoadFeature, setRoadFeatureDialogIsOpen} = useRouteFeatureDialogStoreActions();
    const {gjennomkjoringForbudtFeatures} = props;

     return (
            <>
                {gjennomkjoringForbudtFeatures && gjennomkjoringForbudtFeatures.map((gjennomkjoringForbudt: GjennomkjoringForbudt, index: number) => {
                    return (
                        <Marker key={gjennomkjoringForbudt.uniqueId + index}
                        position={[gjennomkjoringForbudt.location!.y, gjennomkjoringForbudt.location!.x]}
                        icon={gjennomkjoringForbudtIcon}
                        eventHandlers={{
                            click: () => {
                                setClickedRoadFeature(gjennomkjoringForbudt);
                                setRoadFeatureDialogIsOpen(true);
                            }
                        }}
                        />
                    );
                })};
            </>
        );
}